<template>
  <div class="min-h-screen flex flex-col justify-center items-center pt-6 sm:pt-0 p-4">
    <logo></logo>

    <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden rounded-lg">
      <div v-if="success" class="mb-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded">
        Uw wachtwoord is succesvol gewijzigd. U wordt doorgestuurd naar het inlogscherm...
      </div>
      <form @submit.prevent="resetPassword" v-else>
        <div>
          <label class="block font-medium text-sm text-gray-500" for="email">
            Email
          </label>
          <input v-model="data.email"
            class="p-2 rounded-md shadow-sm bg-white border border-gray-300 text-gray-400 block mt-1 w-full" id="email"
            type="email" name="email" required="required" autofocus="autofocus">
        </div>
        <div class="mt-4">
          <label class="block font-medium text-sm text-gray-500" for="password">
            Nieuw Wachtwoord
          </label>
          <input v-model="data.password"
            class="p-2 rounded-md shadow-sm bg-white border border-gray-300 text-gray-400 focus:border-green-500 focus:ring focus:ring-green-500 focus:ring-opacity-50 block mt-1 w-full"
            id="password" type="password" name="password" required="required" autocomplete="new-password">
        </div>
        <div class="mt-4">
          <label class="block font-medium text-sm text-gray-500" for="password_confirmation">
            Bevestig Wachtwoord
          </label>
          <input v-model="data.password_confirmation"
            class="p-2 rounded-md shadow-sm bg-white border border-gray-300 text-gray-400 focus:border-green-500 focus:ring focus:ring-green-500 focus:ring-opacity-50 block mt-1 w-full"
            id="password_confirmation" type="password" name="password_confirmation" required="required"
            autocomplete="new-password">
        </div>
        <div v-if="errors" class="text-red-500 py-2 font-semibold">
          <div v-if="errors.errors">
            <div v-for="(error, field) in errors.errors" :key="field">
              {{ error[0] }}
            </div>
          </div>
          <div v-else-if="errors.message">{{ errors.message }}</div>
        </div>
        <div class="flex items-center justify-end mt-4">
          <button type="submit" :disabled="loading"
            class="inline-flex items-center px-4 py-2 bg-gray-900 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring ring-gray-300 disabled:opacity-25 transition ease-in-out duration-150 ml-3">
            {{ loading ? 'Bezig...' : 'Reset Wachtwoord' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'
import Logo from '@/components/Logo.vue'

export default {
  data: () => {
    return {
      errors: null,
      success: false,
      loading: false,
      data: {
        email: null,
        password: null,
        password_confirmation: null,
      },
    }
  },
  components: {
    Logo,
  },
  setup() {
    const router = useRouter()
    return { router }
  },
  methods: {
    resetPassword() {
      this.errors = null
      this.loading = true
      axios.post('/reset-password', { ...this.data, ...{ token: this.$route.params.token } })
        .then((response) => {
          this.success = true
          this.loading = false
          setTimeout(() => {
            this.router.push({ name: 'Login' })
          }, 2000)
        })
        .catch((error) => {
          this.errors = error.response?.data || { message: 'Er is een fout opgetreden. Probeer het opnieuw.' }
          this.loading = false
        })
    }
  }
}
</script>
